<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
            <app-side-nav [item]="meetingNav"></app-side-nav>
        </div> -->
  <div class="col-12 p-0 employee-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div>

        <div *ngIf="!fromHistory" class="breadcrumbs-section pl-2 ml-5">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/{{individualInviteRoute}}">Invite</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Invite Details</span>
        </div>


        <div *ngIf="fromHistory" class="breadcrumbs-section pl-2 ml-5">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/{{individualInviteRoute}}">Invite</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/history">History</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">History Details</span>
        </div>

        <div class="history-layout">

          <div class="row">
            <div class="col-12">
              <h1>Invite Details</h1>
            </div>
          </div>


          <div class="row mt-4">
            <div class="col-4">
              <p class="title">Full Name</p>
              <p class="result">{{data?.parkUser?.userName}}</p>
            </div>
            <div class="col-4">
              <p class="title">Mobile Number</p>
              <p class="result">{{data?.parkUser?.phoneNumber}}</p>
            </div>
            <div class="col-4">
              <p class="title">Email ID</p>
              <p class="result">{{data?.parkUser?.emailId}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <h2 class="mt-3">Meeting Details</h2>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-2">
              <p class="title">Date</p>
              <p class="result">{{formatDate(data?.mstart, 'date')}}</p>
            </div>
            <div class="col-2">
              <p class="title">Time</p>
              <p class="result">{{formatDate(data?.mstart, 'time')}}</p>
            </div>
            <div class="col-3">
              <p class="title">Building Name</p>
              <p class="result">{{data?.hostCompanyName}}</p>
            </div>
            <div class="col-3">
              <p class="title">Floor</p>
              <p class="result">{{data?.floor}}</p>
            </div>
            <div class="col-2"></div>
          </div>

          <div class="row" *ngIf="data?.isApproved">
            <div class="col-12">
              <p class="green-text">Approved on {{formatDate(data?.approvalDate, 'date')}}</p>
            </div>
          </div>

          <div class="row" *ngIf="!data?.isApproved">
            <div class="col-12">
              <p class="orange-text ">Approval awaited</p>
            </div>
          </div>


          <div *ngIf="individualInvite">
            <div class="row">
              <div class="col-8 title">{{data?.t0600Vmsguests?.length}} Guests</div>
              <div class="col-4 title" style="text-align: right;">Request sent on
                {{formatDate(data?.createdDate, 'date')}}</div>
            </div>

            <div class="guest  mt-3" *ngFor="let item of data?.t0600Vmsguests;let i=index">

              <div class="row">
                <div class="col-12">
                  <h1>Guest {{i+1}}</h1>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-4">
                  <p class="title">Full Name</p>
                  <p class="result">{{item?.fullName}}</p>
                </div>
                <div class="col-4">
                  <p class="title">Mobile Number</p>
                  <p class="result">{{item?.mobile}}</p>
                </div>
                <div class="col-4">
                  <p class="title">Email ID</p>
                  <p class="result">{{item?.email}}</p>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12">
                  <p class="title">Visitor Company Name</p>
                  <p class="result">{{item?.companyName}}</p>
                </div>
              </div>
              <!-- <h3 class="mt-4">Vehicle Details</h3>
              <div class="row mt-4">
                <div class="col-3">
                  <p class="title">Vehicle Type</p>
                  <p class="result">{{getVehicalName(item?.t0600GuestVehicles[0]?.vehicleType)}}</p>
                </div>
                <div class="col-3">
                  <p class="title">Vehicle Number</p>
                  <p class="result">{{item?.t0600GuestVehicles[0]?.vehicleNo}}</p>
                </div>
              </div> -->
            </div>
          </div>


          <div *ngIf="!individualInvite">

            <div class="row">
              <div class="col-8 title">{{data?.t0600Vmsguests?.length}} Guests</div>
              <div class="col-4 title" style="text-align: right;">Request sent on
                {{formatDate(data?.createdDate, 'date')}}</div>
            </div>

            <table class="table table-borderless table-striped table-curved mt-4" id="pdfTable" #pdfTable>
              <thead>
                <tr>

                  <th>Sr.No</th>
                  <th>Guest Name</th>
                  <th>Email Id</th>
                  <th>Contact Number</th>
                  <th></th>

                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let content of data?.t0600Vmsguests;let i=index" [id]="generateUniqueId(i,'th')">

                  <td>{{i+1}}</td>
                  <td>{{content?.fullName}}</td>
                  <td>{{content?.email}}</td>
                  <td>{{content?.mobile}}</td>
                  <td></td>
                  <td>
                    <i class="fa fa-2x fa-trash" aria-hidden="true"
                      (click)="deleteSelected(content?.guestId,i)"></i>
                  </td>
                </tr>

              </tbody>
            </table>

          </div>

        </div>

        <div class="footer-layout" *ngIf="fromHistory">
          <button class="button-resend" (click)="reInvite(data?.t0600Vmsguests[0]?.invitationId,individualInvite)">Re-Invite</button>
        </div>


        <div class="footer-layout" *ngIf="!fromHistory">
          <button class="button-cancel" (click)="cancelInvite(data?.t0600Vmsguests[0]?.invitationId)">Cancel
            Invite</button>
          <button class="button-resend" (click)="resendInvite(data?.t0600Vmsguests[0]?.invitationId)">Resend Invite</button>
        </div>

        <!-- <app-footer></app-footer> -->

      </div>
    </div>
